$('.js-load-more').on('click', function(){
   var $this =$(this);
    totalPages = parseInt($('[data-all-pages]').val()),
    currentPage = parseInt($('[data-this-page]').val()),
    datacollurl = $('[data-coll-url]').val();
    var nextUrl = $('[data-next-link]').val(); 
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
   console.log("current",current_page_new);
   console.log("net page",next_coll);
   console.log("all pages", totalPages);
       $.ajax({
       url: nextUrl,
       type: 'GET',
       dataType: 'html',
       beforeSend: function (){
          $this.find('[loader]').find(".load-more_spinner").css('display',"block");
       },
       success: function(responseHTML){
          $('[data-next-link]').val(datacollurl + "?page="+next_coll);
          $('[data-this-page]').val(current_page_new);
          var ChildHtmlli= $(responseHTML).find('#product-grid').html();
          console.log(ChildHtmlli,'html');
          $('#product-grid').append(ChildHtmlli);
       
         },
         complete: function() {
           if(current_page_new < totalPages) {
               $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide');
               $this.find('[loader]').find(".load-more_spinner").css('display',"none");
           } 
           if(current_page_new >= totalPages) {
               $this.attr('disabled', true);
               $this.find('[load-more-text]').text('No More Products').removeClass('hide');
               $this.find('[loader]').find(".load-more_spinner").css('display',"none");
           } 
           var total_li_count = jQuery('#product-grid li').length;
    jQuery('span.total-products').text(total_li_count);
         }
       });
  
    //console.log(current_page_new)
  }); 